import React from "react";
import NewsletterFourteen from "../component/NewsletterFourteen";

function NewsletterFourteenContainer() {
  return <NewsletterFourteen />;
}

export default NewsletterFourteenContainer;
